import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { Button } from 'react-bootstrap'
import { __, _x } from '@wordpress/i18n'
import { createInterpolateElement } from '@wordpress/element'
export const FormErrorComponent = (props) => {

  const {error, setIsError, setRefreshCaptcha, acf_options} = props
  const {error_name , error_data} = error
  const { data, code, msg, status } = error_data
  const contactPhoneNumber =  acf_options['telefon']? acf_options['telefon']:'(42) 235 31 95'
  const contactLink = _x( '/kontakt', 'Link do kontaktu', 'strefamanagera' )
  React.useEffect(()=>{
    setTimeout(()=>{
      let errorDiv = document.querySelector('#submit-error-div');
      if(errorDiv) {
        errorDiv.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      }
    },500)

  },[])



  if (error_name === 'catch') {
    return (
      <div id={'submit-error-div'} className={'submit-failed-alert'}>
        <FontAwesomeIcon size={'4x'} icon={faCircleExclamation}/>
        <h1>
          {__('Coś poszło nie tak', 'strefamanagera')}
        </h1>
        <p>{__('Przepraszamy, nie udało się dokonać zapisu na wydarzenie.', 'strefamanagera')} <br/>
          {__('Spróbuj ponownie później', 'strefamanagera')}<br/>

          (F-{error_data.request? error_data.request.status:'500' })

        </p>
        <div className={'btn-return'}>
          <Button onClick={()=>{
            setIsError(false);
          }} size={'lg'}>{__('Wróć do formularza', 'strefamanagera')}</Button>
        </div>
      </div>
    )
  }

  if ( error_name === 'api' &&  code){
    let errorComponent;
    switch (code){
      case 464:
        errorComponent =
          <div id={'submit-error-div'} className={'submit-failed-alert'}>
            <FontAwesomeIcon size={'4x'} icon={faCircleExclamation}/>
            <h1>
            {__('Wystąpił błąd podczas próby zgłoszenia', 'strefamanagera')}
            </h1>

            <p>{__('Przepraszamy, nie udało się dokonać zapisu.', 'strefamanagera')}<br/><br/>
              <b>{__('Poniższe adresy mailowe zostały już wykorzystane do zgłoszenia na to wydarzenie.', 'strefamanagera')}</b><br/><br/>
            </p>
            <p className={'solution'}>
              {__('Usuń podanych uczestników lub zmień ich adresy mailowe.', 'strefamanagera')}
            </p>
            <ol>
              {data.already_used.map((email)=>(
                <li>{email}</li>
              ))}
            </ol>
            <br/>
            <div className={'btn-return'}>
              <Button onClick={()=>{
                setIsError(false);
              }} size={'lg'}>{__('Wróć do formularza', 'strefamanagera')}</Button>
            </div>
          </div>
        break;
      case 476:
        errorComponent =
          <div id={'submit-error-div'} className={'submit-failed-alert'}>
            <FontAwesomeIcon size={'4x'} icon={faCircleExclamation}/>
            <h1> Wystąpił błąd podczas próby zgłoszenia</h1>
            <div className={'solutionContainerWrapper'}>
              <div className={'solutionContainer'}>
                <p className={'solution_no_upper_case'} >
                {__('Przepraszamy, nie udało się dokonać zapisu.', 'strefamanagera')}
                <br/>
                <b>{__('Podany e‑mail został już wykorzystany do zapisu na to wydarzenie.', 'strefamanagera')}</b>
                <br/>
                <br/>
              </p>
              <p className={'solution_no_upper_case'} > 
                {createInterpolateElement(
                  __('Jeśli już zgłosiłeś/aś się na to wydarzenie, wkrótce otrzymasz e-mail potwierdzający zapis.<br /> Jeśli nie zgłaszałeś/aś się na to wydarzenie, użyj innego adresu e-mail lub skontaktuj się z naszym biurem obsługi poprzez<br /> <a>formularz kontaktowy</a> lub pod numerem <aPhoneNumber />', 'strefamanagera'),
                  {
                    a: <a href={contactLink}></a>,
                    aPhoneNumber: <a href={'tel:'+contactPhoneNumber}>{contactPhoneNumber}</a>,
                    br: <br />
                  }
                )}
                  <br/>
                  ({code})
                </p>
              </div>
            </div>


            <br/>
            <div className={'btn-return'}>
              <Button onClick={()=>{
                setIsError(false);
              }} size={'lg'}>{__('Wróć do formularza', 'strefamanagera')}</Button>
            </div>
          </div>
        break;
      case 472:
        errorComponent =
          <div id={'submit-error-div'} className={'submit-failed-alert'}>
            <FontAwesomeIcon size={'4x'} icon={faCircleExclamation}/>
            <h1>
                {__('Wydarzenie zostało odwołane', 'strefamanagera')}
            </h1>

            <p>
              {__('Przepraszamy, ale wybrany przez Ciebie termin wydarzenia został właśnie odwołany.', 'strefamanagera')}
            </p>
            <p className={'solution'}>
              {__('Wróć do formularza i wybierz inny termin lub skorzystaj z innego wydarzenia.', 'strefamanagera')}
            </p>

            <br/>
            <div className={'btn-return'}>
              <Button onClick={()=>{
                setIsError(false);
              }} size={'lg'}>{__('Wróć do formularza', 'strefamanagera')}</Button>
            </div>
          </div>
        break
      case 478:
        errorComponent = <div id={'submit-error-div'} className={'submit-failed-alert'}>
          <FontAwesomeIcon size={'4x'} icon={faCircleExclamation}/>
          <h1>
            {__('Wystąpił problem przy próbie zapisu na wydarzenie.', 'strefamanagera')}
          </h1>
          <p>
            {createInterpolateElement(
              __('Spróbuj ponownie. Jeśli problem się powtórzy skontaktuj się z naszym biurem obsługi poprzez<br /><a>formularz kontaktowy</a> lub pod numerem <aPhoneNumber />', 'strefamanagera'),
              {
                a: <a href={contactLink}></a>,
                aPhoneNumber: <a href={'tel:'+contactPhoneNumber}>{contactPhoneNumber}</a>,
                br: <br />
              }
            )}
            <br/>
            ({code})


          </p>
            <div className={'btn-return'}>
              <Button onClick={()=>{
                setIsError(false);
                setRefreshCaptcha(true)
              }} size={'lg'}>{__('Wróć do formularza', 'strefamanagera')}</Button>
            </div>
        </div>
        break
      default:
        errorComponent = <div id={'submit-error-div'} className={'submit-failed-alert'}>
          <FontAwesomeIcon size={'4x'} icon={faCircleExclamation}/>
          <h1>
          {__('Coś poszło nie tak', 'strefamanagera')}
          </h1>
          <p>
            {__('Przepraszamy, nie udało się dokonać zapisu na wydarzenie.', 'strefamanagera')}
            <br/>
            {__('Spróbuj ponownie później', 'strefamanagera')}
            <br/>
            ({code})


          </p>
          <div className={'btn-return'}>
            <Button onClick={()=>{
              setIsError(false);
            }} size={'lg'}>{__('Wróć do formularza', 'strefamanagera')}</Button>
          </div>
        </div>
    }
    return errorComponent;
  }
}
FormErrorComponent.defaultProps={
  acf_options:[],
}


export function shouldDisplayError (errors, touched, name) {
  let testName = name.split('.')
  if (Array.isArray(testName) && testName.length > 1) {
    //logika sprawdzenia czy istnieją błedy dla pól uczestnikow
    let isError, isTouched
    try {

      //                       participants     0      firstName
      isError = errors[testName[0]][parseInt(testName[1])][testName[2]]
      isTouched = touched[testName[0]][parseInt(testName[1])][testName[2]]

    } catch (err) {
      return false
    }
    if (isError && isTouched) {
      return true
    }
    return false

  } else {
    return errors[name] && touched[name]
  }
}